import { useCallback } from 'react';

import {
  useRecordContext,
  useCreate,
  useGetOne,
  useNotify,
  usePermissions,
  useRefresh,
  useResourceContext,
} from 'react-admin';

import errorNotification from '../utilities/errorNotification';
import hasAccess from '../utilities/hasAccess';

import { Actions } from '../constants/actions';

const useEntityData = <T extends { id: string }>({
  source,
  getAction,
  resource,
}: {
  source: string;
  getAction: Actions;
  resource?: string;
}) => {
  const record = useRecordContext<T>();
  const { permissions } = usePermissions<Actions[]>();
  const resourceParam = useResourceContext();
  const refresh = useRefresh();
  const notify = useNotify();

  const [purchase, { isLoading }] = useCreate(
    `${resource ?? resourceParam}/${source}/${record?.id}`,
    { data: {} },
    {
      onSuccess: () => {
        refresh();
        notify('Successful', { type: 'success' });
      },
      onError: (error) => {
        notify(errorNotification(error), { type: 'error' });
      },
    },
  );

  const { data } = useGetOne<T>(
    `${resource ?? resourceParam}/${source}`,
    { id: record?.id! },
    { enabled: !!record?.id && hasAccess(permissions, getAction) },
  );

  const handlePurchase = useCallback(() => {
    purchase();
  }, [purchase]);

  return { handlePurchase, isLoading, data };
};

export default useEntityData;
